import { Routes } from "@angular/router";
import { AppLayout } from "@/layout/components/app.layout";
import { authGuard } from "@/core/guards/auth.guard";

export const appRoutes: Routes = [
  {
    path: "login",
    loadComponent: () =>
      import("@/features/auth/pages/login/login.component").then(
        (c) => c.LoginComponent
      ),
  },
  {
    path: "forgot-password",
    loadComponent: () =>
      import(
        "@/features/auth/pages/forgot-password/forgot-password.component"
      ).then((c) => c.ForgotPasswordComponent),
  },
  {
    path: "change-password",
    loadComponent: () =>
      import(
        "@/features/auth/pages/change-password/change-password.component"
      ).then((c) => c.ChangePasswordComponent),
  },
  {
    path: "",
    component: AppLayout,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('@/features/dashboard/pages/dashboard-page/dashboard-page').then((c) => c.DashboardPage),
        data: { breadcrumb: 'Dashboard' }
      },
      {
        path:"dashboard-info/:id",
        loadComponent:() => import('@/features/dashboard/pages/dashboard-info/dashboard-info').then((m)=>m.DashboardInfo),
        data:{ breadcrumb: 'Dashboard Info' }
      },
      {
        path: "user-accounts",
        loadChildren: () =>
          import("@/features/user-accounts/user-accounts-routing-module").then(
            (m) => m.UserAccountsRoutingModule
          ),
        data: { breadcrumb: "User Accounts" },
      },
      {
        path: "roles",
        loadChildren: () =>
          import("@/features/roles/roles-routing-module").then(
            (m) => m.RolesRoutingModule
          ),
        data: { breadcrumb: "Roles" },
      },
      {
        path: "purchase-request-management",
        loadChildren: () =>
          import("@/features/order/order-routing-module").then(
            (m) => m.OrderRoutingModule
          ),
        data: { breadcrumb: "ใบคำขอสั่งซื้อ" },
      },
      {
        path: "cash-purchase-request-management",
        loadChildren: () =>
          import("@/features/cash-purchase/cash-purchase-routing-module").then(
            (m) => m.CashPurchaseRoutingModule
          ),
        data: { breadcrumb: "ใบคำสั่งซื้อเงินสดย่อย" },
      },
      {
        path: "document-dispatch",
        loadChildren: () =>
          import("@/features/document-dispatch/document-dispatch-routing-module").then(
            (m) => m.DocumentDispatchRoutingModule
          ),
        data: { breadcrumb: "จัดส่งเอกสาร" },
      }
    ],
  },

  // { path: '**', redirectTo: '/notfound' }
];
